// extracted by mini-css-extract-plugin
export var quillEditor = "_p1-1";
export var variable = "_p1-0";